var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-container"
  }, [_c("el-select", {
    attrs: {
      name: "action",
      placeholder: "Action",
      clearable: ""
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.action,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "action", $$v);
      },
      expression: "listQuery.action"
    }
  }, _vm._l(_vm.actionOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1), _c("VueCtkDateTimePicker", {
    staticClass: "filter-item",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      range: "",
      formatted: "DD-MM-YYYY",
      "custom-shortcuts": _vm.shortcuts
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      icon: "el-icon-search",
      size: "mini"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-document"
    },
    on: {
      click: _vm.handleExcelDownload
    }
  }, [_vm._v(" Export as Excel ")])], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Product",
      prop: "productId",
      width: "350",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", [_vm._v(_vm._s(`${scope.row.product.catalogueCode} - ${scope.row.product.name}`))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      align: "center",
      label: "Color",
      prop: "productsVariationId"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", [_vm._v(_vm._s(scope.row.productsVariation.name))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      align: "center",
      label: "Voucher Number"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        var _scope$row$ordersDisp, _scope$row$ordersDisp2, _scope$row$ledger;
        return [scope.row.ordersDispatchId ? _c("el-link", {
          attrs: {
            type: "primary",
            target: "_blank"
          },
          on: {
            click: function ($event) {
              return _vm.viewDispatchInvoice(scope.row.ordersDispatchId);
            }
          }
        }, [_vm._v(" " + _vm._s((_scope$row$ordersDisp = scope.row.ordersDispatch) !== null && _scope$row$ordersDisp !== void 0 && _scope$row$ordersDisp.invoiceNumber ? scope.row.ordersDispatch.invoiceNumber : ((_scope$row$ordersDisp2 = scope.row.ordersDispatch) === null || _scope$row$ordersDisp2 === void 0 ? void 0 : _scope$row$ordersDisp2.entryNumber) || "N/A") + " ")]) : scope.row.ledgerId ? _c("el-link", {
          attrs: {
            type: "primary",
            target: "_blank"
          },
          on: {
            click: function ($event) {
              return _vm.viewCNDNInvoice(scope.row.ledgerId);
            }
          }
        }, [_vm._v(" " + _vm._s(((_scope$row$ledger = scope.row.ledger) === null || _scope$row$ledger === void 0 ? void 0 : _scope$row$ledger.ledgerInvoiceNumber) || "N/A") + " ")]) : _c("span", [_vm._v("N/A")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      align: "center",
      label: "Vch. Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        var _scope$row$ordersDisp3, _scope$row$ordersDisp4;
        return [_c("el-tag", {
          attrs: {
            size: "mini",
            type: _vm.statusColorMap[(_scope$row$ordersDisp3 = scope.row.ordersDispatch) === null || _scope$row$ordersDisp3 === void 0 ? void 0 : _scope$row$ordersDisp3.status] || "info"
          }
        }, [_vm._v(" " + _vm._s(((_scope$row$ordersDisp4 = scope.row.ordersDispatch) === null || _scope$row$ordersDisp4 === void 0 ? void 0 : _scope$row$ordersDisp4.status) || "N/A") + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      align: "center",
      label: "Action",
      prop: "action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tag", {
          attrs: {
            type: scope.row.action === "outward" ? "danger" : "success"
          }
        }, [_vm._v(" " + _vm._s(scope.row.action.toUpperCase()) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      align: "center",
      label: "Quantity",
      prop: "productsVariationId"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button", {
          attrs: {
            type: "primary",
            round: "",
            size: "mini"
          }
        }, [_vm._v(" " + _vm._s(scope.row.quantity) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      align: "center",
      label: "Date",
      prop: "createdTimestamp"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm._f("moment")(scope.row.createdTimestamp, "DD-MM-YYYY")) + " ")];
      }
    }])
  })], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };